module.exports = __webpack_public_path__ + "static/media/8.6d38cf18.jpg";